import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import CGU from './pages/CGU';
import Cookies from './pages/Cookies';
import './App.css';

/**
 * Main App Component
 * Handles routing for all pages
 */
function App() {
  return (
    <Router>
      <div className="app">
        <main className="app__main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
